import {
  ARMOR_SLOTS,
  STRESS,
} from '../../character/content/templates';

export default function Equipment() {
    return (
        <>
            <p>
                Your equipped weapons and armor are the ones listed in
                the “Active Weapons” and “Active Armor” sections of your
                character sheet. Your character can only attack with weapons,
                benefit from armor, and gain features from items they have
                equipped. You can't equip weapons or armor with a higher tier
                than you.
                <p>PCs can carry up to two additional weapons in the “Inventory
                    Weapon” areas of the character sheet.</p>
                <p>You can swap an Inventory Weapon with an Active Weapon at
                    no cost during a rest or moment of calm; otherwise, you must
                    mark a {STRESS} to do so.</p>
                <p>Your character can only have one Active Armor at a time.</p>
                They can't equip armor while in danger or under pressure;
                otherwise, they can equip or unequip armor without cost.
                Each armor has its own {ARMOR_SLOTS}; if your character
                unequips their armor, track how many of its {ARMOR_SLOTS} are
                marked. You can't carry armor in your inventory. When your
                character equips or unequips armor, recalculate your damage
                thresholds
            </p>
        </>
    );
}